import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch, useSelector } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import check from "../../assets/images/workPreferences/check.png";
import line1 from "../../assets/images/workPreferences/line1.png";
import line2 from "../../assets/images/workPreferences/line2.png";
import line3 from "../../assets/images/workPreferences/line3.png";
import line4 from "../../assets/images/workPreferences/line4.png";
import women from "../../assets/images/workPreferences/women.png";
import men from "../../assets/images/workPreferences/men.png";
import {
  GET_GYM_PREFRENCES_ENDPOINT,
  POST_WORKOUT_PREFRENCES,
} from "../../config/ApisCollection";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function ProfileInfoUpdate() {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const [personImg, setPersonImg] = useState(null);
  const [errMsg, setErrorMsg] = useState(null);
  const dispatch = useDispatch();
  let history = useNavigate();
  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(null));
    await dispatch(setIsDrawerActive(false));

    // await dispatch(setDrawerActiveMenu(31));
  };
  const [gender] = useState("men");
  const [bodyOptions, setBodyOptions] = useState([]);
  const [selectedBodyOptions, setSelectedBodyOptions] = useState([]);
  const [bodyTarget, setBodyTarget] = useState([
    { name: "pecs", isTrue: false },
    {
      name: "belly",
      isTrue: false,
    },
    {
      name: "buttocks",
      isTrue: false,
    },
    { name: "legs", isTrue: false },
  ]);
  const accessToken = secureLocalStorage.getItem("accessToken");

  const handleToggle = async (index) => {
    const updatedBodyTarget = bodyTarget.map((target, idx) =>
      idx === index
        ? {
            ...target,
            isTrue: !target.isTrue,
          }
        : {
            ...target,
            isTrue: false,
          }
    );

    setBodyTarget(updatedBodyTarget);
  };

  const GetPrefrencesesData = async () => {
    let api_url = `${GET_GYM_PREFRENCES_ENDPOINT}`;

    const post_header = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios.get(api_url, post_header).then((response) => {
        setBodyOptions(Object.entries(response.data));
        setPersonImg(response.data.backgroundimg);

        // console.log(response.data);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const PostPrefrencesData = async () => {
    let targetzone = [];
    bodyTarget.forEach((item, index) => {
      if (item.isTrue == true) {
        targetzone.push(item.name);
      }
    });

    if (targetzone[0] == undefined) {
      setErrorMsg("Invalid request");
      setTimeout(() => {
        setErrorMsg(null);
      }, 3000);
    } else {
      handleCloseDrawer();
      window.location.href = "/gym/explore/" + targetzone[0];
    }

    // const post_body = {
    //   targetzone: targetzone,
    // };

    // const post_header = {
    //   headers: {
    //     Authorization: "Bearer " + accessToken,
    //     "Content-Type": "application/json",
    //   },
    // };
    // try {
    //   await axios
    //     .post(POST_WORKOUT_PREFRENCES, post_body, post_header)
    //     .then((response) => {
    //       console.log(response.data);
    //     });
    // } catch (error) {
    //   console.log(error);
    // }
  };

  useEffect(() => {
    GetPrefrencesesData();
  }, []);
  // console.log(bodyTarget);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      {bodyTarget && bodyTarget && personImg ? (
        <div className="text-center w-11/12 mt-2 mx-auto pb-8 gap-6 flex flex-col justify-between">
          <p className="text-2xl font-medium">
            What target zones do you want{" "}
            <span className="text-[#FF9950]"> to work on</span> ?
          </p>
          <div className="flex gap-6 w-full">
            {gender === "men" && personImg != null ? (
              <div className="relative w-[45%]">
                <img
                  src={personImg}
                  alt="workoutladey"
                  height={405}
                  width={136}
                  className="h-[405px] w-[136px]"
                />
                <div
                  className="absolute w-[70%] flex items-center top-[6rem] -right-6"
                  key={1}
                >
                  <img src={line1} alt="workoutladey" />
                </div>
                <div
                  className="absolute w-[70%] flex items-center top-[9rem] -right-6"
                  key={2}
                >
                  <img src={line2} alt="workoutladey" />
                </div>
                <div
                  className="absolute w-[53%] flex items-center top-[11.7rem] -right-6"
                  key={3}
                >
                  <img src={line3} alt="workoutladey" />
                </div>
                <div
                  className="absolute w-[60%] flex items-center top-[18rem] -right-6"
                  key={4}
                >
                  <img src={line4} alt="workoutladey" />
                </div>
              </div>
            ) : personImg != null ? (
              <div className="relative w-[45%]">
                <img
                  src={personImg}
                  alt="workoutladey"
                  height={405}
                  width={136}
                />
                <div
                  className="absolute w-[70%] flex items-center top-[5.5rem] -right-6"
                  key={1}
                >
                  <img src={line1} alt="workoutladey" />
                </div>
                <div
                  className="absolute w-[70%] flex items-center top-[8rem] -right-6"
                  key={2}
                >
                  <img src={line2} alt="workoutladey" />
                </div>
                <div
                  className="absolute w-[53%] flex items-center top-[10.7rem] -right-6"
                  key={3}
                >
                  <img src={line3} alt="workoutladey" />
                </div>
                <div
                  className="absolute w-[60%] flex items-center top-[15.9rem] -right-6"
                  key={4}
                >
                  <img src={line4} alt="workoutladey" />
                </div>
              </div>
            ) : (
              <></>
            )}
            {personImg ? (
              <div className="flex flex-col justify-center gap-5 w-6/12 mt-2 items-center">
                {bodyTarget &&
                  bodyTarget?.map((option, index) => (
                    <div
                      key={index}
                      className={`flex border gap-3 cursor-pointer rounded-2xl items-center w-full px-4 py-4 ${
                        option?.isTrue == true
                          ? "border-gray-200 !border-[#FF9950]"
                          : ""
                      } `}
                      onClick={() => {
                        handleToggle(index);
                      }}
                    >
                      {/* {console.log(option)} */}
                      <div
                        className={`rounded-lg flex items-center justify-center w-7 h-7 border ${
                          option?.isTrue == true
                            ? " border-gray-200 bg-gray-300 bg-gray-100 !border-[#FF9950]"
                            : "ddddd"
                        }`}
                      >
                        <img
                          src={check}
                          alt="check"
                          className={option?.isTrue == true ? "" : "hidden"}
                        />
                      </div>
                      <span className="text-xs font-medium text-capitalize">
                        {option.name}
                      </span>
                    </div>
                  ))}
              </div>
            ) : (
              <></>
            )}
          </div>
          <p className="text-[red]">{errMsg}</p>
          <button
            className="text-center w-10/12 mx-auto cursor-pointer bg-[#FF9950] py-3.5 rounded-xl"
            onClick={PostPrefrencesData}
          >
            <p className="text-lg text-white font-medium">Explore workout</p>
          </button>
        </div>
      ) : (
        <div className="flex flex-col justify-center h-[80vh]">
          <p class="text-center">Loading...</p>
        </div>
      )}
    </div>
  );
}
